import { Link } from "react-router-dom";
import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import { useTheme } from "@/context/ThemeContext";

export function MinimalNavBar() {
  const { theme, toggleTheme } = useTheme();

  return (
    <nav className="sticky top-0 z-40 flex items-center gap-6 px-6 py-3 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <Link
        to="/dashboard"
        className="flex items-center gap-2 font-bold text-lg text-slate-900 dark:text-slate-100 no-underline"
      >
        <img src="/android-chrome-192x192.png" alt="" aria-hidden="true" className="h-[44px] w-[44px]" />
        Jobs Bot
      </Link>
      <div className="flex items-center gap-6">
        <Link
          to="/login"
          className="text-sm text-slate-600 dark:text-slate-400 no-underline hover:text-slate-900 dark:hover:text-slate-100 transition-colors duration-200"
        >
          Sign in
        </Link>
        <Link
          to="/register"
          className="text-sm text-slate-600 dark:text-slate-400 no-underline hover:text-slate-900 dark:hover:text-slate-100 transition-colors duration-200"
        >
          Register
        </Link>
        <Link
          to="/help"
          className="text-sm text-slate-600 dark:text-slate-400 no-underline hover:text-slate-900 dark:hover:text-slate-100 transition-colors duration-200"
        >
          Help
        </Link>
      </div>
      <button
        onClick={toggleTheme}
        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
        className="ml-auto p-1.5 rounded text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all duration-200 min-h-[44px] min-w-[44px] flex items-center justify-center"
      >
        {theme === "dark" ? (
          <SunIcon className="h-5 w-5" aria-hidden="true" />
        ) : (
          <MoonIcon className="h-5 w-5" aria-hidden="true" />
        )}
      </button>
    </nav>
  );
}
